import '../assets/css/tables.css'
import { getSQLDateFormat } from '../utilities/general-utils'

const PaymentSchedule = (props) => {
    return (
        <div
            className={`standardTableWrap`}
        >
            <div className="responsive-table-wrap">
                <table
                    className={`standardTable ${props.className} spc-m-x-auto`}
                    style={{ margin: "0 auto" }}
                >
                    <thead>
                        <tr>
                            <th style={{width: "calc(100% * (1/9))"}}>Payment #</th>
                            <th style={{width: "calc(100% * (1/9))"}}>Date</th>
                            <th style={{width: "calc(100% * (1/9))"}}>Rate</th>
                            <th style={{width: "calc(100% * (1/9))"}}>Payment</th>
                            <th style={{width: "calc(100% * (1/9))"}}>Extra</th>
                            <th style={{width: "calc(100% * (1/9))"}}>Total</th>
                            <th style={{width: "calc(100% * (1/9))"}}>Interest</th>
                            <th style={{width: "calc(100% * (1/9))"}}>Principal</th>
                            <th style={{width: "calc(100% * (1/9))"}}>Balance</th>
                        </tr>
                    </thead>

                    <tbody>
                        {props.data.map((row) => {
                            return (
                                <tr key={`x-${row.paymentNumber}-${row.balance}`}>
                                    <td className="text-center">{row.paymentNumber}</td>
                                    <td className="text-center">{getSQLDateFormat(new Date(row.date))}</td>
                                    <td className="text-right">{row.rate}</td>
                                    <td className="text-right">
                                        ${parseFloat(row.payment).toFixed(2)}
                                    </td>
                                    <td className="text-right">
                                        $
                                        {parseFloat(row.extraPayment).toFixed(
                                            2
                                        )}
                                    </td>
                                    <td className="text-right">
                                        $
                                        {parseFloat(row.totalPayment).toFixed(
                                            2
                                        )}
                                    </td>
                                    <td className="text-right">
                                        ${parseFloat(row.interestPaid).toFixed(2)}
                                    </td>
                                    <td className="text-right">
                                        ${parseFloat(row.principalPaid).toFixed(2)}
                                    </td>
                                    <td className="text-right">
                                        ${parseFloat(row.balance).toFixed(2)}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default PaymentSchedule